<template>
    <div class="panel_container"  :class="{ pp_group: props.groupName === 'PP' }" :style="{ color: customStyles.active_font_color }">
        <van-row justify="space-between" style="margin-bottom: 10px;">
            <van-col span="1" class="left-borer"></van-col>
            <van-col span="15" class="group_col"> 
                <img :src="props.groupImage" alt="">
                <div @click="() => emits('goGamePannel')" class="game_count"
                    :style="{ color: customStyles.border_color, border: `0.5px solid ${customStyles.border_color}` }">{{
                        gameCount }}</div>
            </van-col>
            <van-col span="8" class="group_col_right">
                <div class="more_button" @click="() => emits('goGamePannel')">
                    <div>{{$t('common.more') }}</div>
                    <img src="@/assets/home/play.png" alt="">
                </div>
            </van-col>
        </van-row>
        <div class="game-slider-container">
            <div class="arrow left" @click="prevPage"><img src="@/assets/home/game_arrow_white.png" alt=""></div>
            <div class="arrow right" @click="nextPage"><img src="@/assets/home/game_arrow_white.png" alt="">
            </div>

            <van-grid :column-num="gameGrid.columnCount" :gutter="2" :border="false">
                <van-grid-item v-for="item in paginatedGameList" :key="item.id">
                    <GameCard :gameImage="item.customIcon" :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                        @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite,item.id)" />
                </van-grid-item>
            </van-grid>
        </div>
        <div class="bottom_text" @click="() => emits('goGamePannel')">{{ $t('common.loadMore') }}
            <img src="@/assets/home/down_arrow.png" alt="">
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineProps, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';

const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = defineProps({
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    }

})
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = defineEmits([ 'goGamePannel'])
const currentPage = ref(0)
const pageSize = computed(() => {
    return gameGrid.value.rowCount * gameGrid.value.columnCount
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})

const nextPage = () => {
    if(process.env.VUE_APP_PREVIEW_MODE == 'true'){ return }
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        currentPage.value++
    }
}

const prevPage = () => {
    if(process.env.VUE_APP_PREVIEW_MODE == 'true'){ return }
    if (currentPage.value > 0) {
        playClickSound()
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId:number) => {
  goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})
</script>
<style scoped>
.panel_container {
    padding: 5px 0;
    /* color: #fff; */
    font-weight: 600;
    /* min-height: 337px; */
}

.group_col {
    display: flex;
    padding: 5px;
    align-items: center;
}

.group_col img {
    width: auto !important;
}

.left-borer{
    border-right: 4px solid #dd8b33;
    margin: 3px 0px;
}

.group_name {
    /* color: #fff; */
    font-size: 15.4px;
    padding: 5px;
    font-weight: 700;
}

.group_col_right {
    display: flex;
    align-items: center;
    justify-content: right;
}


.group_col img {
    width: 100px;
    height: 30px;
}

.more_button {
    display: flex;
    align-items: center;
    background: #ffa54314;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
    padding-right: 3px;
}

.game_list {
    display: flex;
    justify-content: left;
    padding: 5px;
}

.game_count {
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    /* color: #DD7A33;
    border: 0.5px solid #DD7A33; */
    border-radius: 5px;
    padding: 3px 8px;
}

.more_button img {
    width: 17px;
    padding-left: 5px;
}

.game-slider-container {
    position: relative;
}

.game-slider-container>>>.van-grid-item__content {
    background-color: transparent;
    padding: 2.5px;
}

.game-slider-container>>>.van-grid-item__content:after {
    border: none;
}

.arrow {
    position: absolute;
    top: 40%;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 10;
    border-radius: 50%;
    user-select: none;
}

.arrow.left {
    left: 0;
}

.arrow.left img {
    width: 15px;
    margin-left: -5px;
}

.arrow.right {
    right: 0;
}

.arrow.right img {
    width: 15px;
    transform: rotate(180deg);
    margin-right: -15px;
}

.bottom_text {
    color: #d1d1d1;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
}

.bottom_text img {
    width: 10px;
    background: rgba(0, 0, 0, 0.65);
    padding: 3px;
    border-radius: 30px;
    margin-left: 5px;
}




</style>